import {
  ADD_TOAST,
  REMOVE_TOAST,
  ADD_TOAST_FROM_QUEUE
} from 'typeConstants';
import { snackbar as initialState } from '../initialState.tsx';

function toastsAreSame(t1, t2) {
  try {
    return t1.text[0].props.children[0] === t2.text[0].props.children[0];
  } catch (e) {
    // no empty
  }
  return false;
}

const snackbar = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TOAST:
      if(state.toasts.length) {
        if (toastsAreSame(state.toasts[0], action.toast)) {
          // do not serve duplicate Toast messages, it's rude and unhealthy
          return state;
        }
        return {
          ...state,
          toastsQueue: [
            ...state.toastsQueue,
            {
              toasts: action.toast,
              autohide: action.autohide,
              className: action.className
            }
          ]
        };
      }
      return {
        ...state,
        toasts: [...state.toasts, action.toast],
        autohide: action.autohide,
        className: action.className
      };
    case REMOVE_TOAST:
      return {
        ...state,
        toasts: [],
      };
    case ADD_TOAST_FROM_QUEUE:
      if(state.toastsQueue.length) {
        return {
          ...state,
          toasts: [state.toastsQueue[0].toasts],
          autohide: state.toastsQueue[0].autohide,
          className: state.toastsQueue[0].className,
          toastsQueue: state.toastsQueue.slice(1),
        };
      }
      return state;

    default:
      return state;
  }
};

export default snackbar;

